import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../contexts/ToastContext';
import departmentService from '../services/departmentService';
import './SetupDepartment.css';

const TYPES = [
  { value: 'fire', label: 'Fire' },
  { value: 'police', label: 'Police' },
  { value: 'ems', label: 'EMS' },
  { value: 'sheriff', label: 'Sheriff' },
  { value: 'search_and_rescue', label: 'Search & Rescue' },
  { value: 'other', label: 'Other' },
];

const EMPTY = {
  name: '',
  type: 'fire',
  color: '#C62828',
  phone: '',
  street: '',
  city: '',
  state: '',
  zip: '',
  country: 'USA',
  logo_url: '',
};

function SetupDepartment() {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) {
      addToast('Department name is required', 'error');
      return;
    }

    setLoading(true);
    try {
      const body = {
        ...form,
        name: form.name.trim(),
        logo_url: form.logo_url.trim() || null,
        phone: form.phone.trim() || null,
        street: form.street.trim() || null,
        city: form.city.trim() || null,
        state: form.state.trim() || null,
        zip: form.zip.trim() || null,
        country: form.country.trim() || null,
      };
      const data = await departmentService.createDepartment(body);
      addToast('Department created successfully', 'success');
      navigate(`/departments/${data.id}`);
    } catch (err) {
      addToast(err.message || 'Failed to create department', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="setup-department">
      <h1>Set Up Your Department</h1>
      <p className="subtitle">Create the department or agency you lead.</p>

      <form onSubmit={handleSubmit} className="setup-form">
        <label>
          Department name
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Lincoln Volunteer Fire Department"
            required
          />
        </label>

        <div className="row">
          <label>
            Function / type
            <select name="type" value={form.type} onChange={handleChange}>
              {TYPES.map((t) => (
                <option key={t.value} value={t.value}>
                  {t.label}
                </option>
              ))}
            </select>
          </label>

          <label>
            Badge color
            <input
              type="text"
              name="color"
              value={form.color}
              onChange={handleChange}
              placeholder="#C62828"
            />
          </label>
        </div>

        <label>
          Department phone
          <input
            type="text"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="(402) 555-0199"
          />
        </label>

        <label>
          Street address
          <input
            type="text"
            name="street"
            value={form.street}
            onChange={handleChange}
            placeholder="456 Station Road"
          />
        </label>

        <div className="row">
          <label>
            City
            <input type="text" name="city" value={form.city} onChange={handleChange} />
          </label>
          <label>
            State
            <input type="text" name="state" value={form.state} onChange={handleChange} />
          </label>
        </div>

        <div className="row">
          <label>
            ZIP / postal code
            <input type="text" name="zip" value={form.zip} onChange={handleChange} />
          </label>
          <label>
            Country
            <input type="text" name="country" value={form.country} onChange={handleChange} />
          </label>
        </div>

        <label>
          Logo URL (optional)
          <input
            type="url"
            name="logo_url"
            value={form.logo_url}
            onChange={handleChange}
            placeholder="https://example.com/logo.png"
          />
        </label>

        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? 'Creating...' : 'Create Department'}
        </button>
      </form>
    </div>
  );
}

export default SetupDepartment;
